// eslint-disable-next-line @github-ui/github-monorepo/filename-convention
import {JetBrains as SvgJetBrains, VSCode as SvgVsCode} from '@github-ui/brand-core/ide-icons'

import type {ProductAnnouncementData} from './../components/ProductAnnouncement/ProductAnnouncement.types'
import ImageModalTab1Dark from './assets/ccaOnboarding/modal/tab1-dark.webp'
import ImageModalTab1Light from './assets/ccaOnboarding/modal/tab1-light.webp'
import ImageModalTab2Dark from './assets/ccaOnboarding/modal/tab2-dark.webp'
import ImageModalTab2Light from './assets/ccaOnboarding/modal/tab2-light.webp'
import ImageModalTab3Dark from './assets/ccaOnboarding/modal/tab3-dark.webp'
import ImageModalTab3Light from './assets/ccaOnboarding/modal/tab3-light.webp'

const getData = (): ProductAnnouncementData => {
  return {
    modal: {
      title: 'Get started with Copilot',
      label: 'Copilot Business',
      body: 'Connect Copilot to your workflow and put agents to work on real tasks.',
      cta1: {
        label: 'Get started',
        href: '/in-product-messaging/dismiss-and-redirect?notice=accelerate_ipm_copilot_business_onboarding_modal&group=engage&dismiss_scope=user&destination_key=accelerate_ipm_copilot_business_onboarding_modal_copilot',
      },
      tabs: [
        {
          title: 'Set up Copilot',
          heading: 'Copilot works where you work',
          description:
            'Work in your CLI, build in your IDE, and ship on GitHub. Copilot runs across your entire toolchain.',
          visual: {
            type: 'image',
            src: {
              light: ImageModalTab1Light,
              dark: ImageModalTab1Dark,
            },
            alt: 'Placeholder preview for setting up Copilot across the CLI and IDE.',
          },
          dropdown: {
            label: 'Set up where you work',
            sections: [
              {
                type: 'input',
                label: 'Set up in CLI',
                value: 'brew install copilot-cli',
                copyButtonLabel: 'Copy the Copilot CLI install command',
              },
              {
                type: 'items',
                heading: 'Set up in IDE',
                items: [
                  {
                    id: 'vscode',
                    label: 'VS Code',
                    href: 'https://code.visualstudio.com/docs/copilot/setup',
                    isNewWindow: true,
                    icon: {
                      src: SvgVsCode,
                      alt: '',
                    },
                  },
                  {
                    id: 'jetbrains',
                    label: 'JetBrains',
                    href: 'https://docs.github.com/en/copilot/how-tos/set-up/install-copilot-extension?tool=jetbrains#installing-the-github-copilot-plugin-in-your-jetbrains-ide',
                    isNewWindow: true,
                    icon: {
                      src: SvgJetBrains,
                      alt: '',
                    },
                  },
                  {
                    id: 'more',
                    label: 'More',
                    href: `https://docs.github.com/en/copilot/how-tos/set-up/install-copilot-extension`,
                    isNewWindow: true,
                    icon: 'KebabHorizontalIcon',
                  },
                ],
              },
            ],
          },
        },
        {
          title: 'Plan, delegate, or manage work',
          heading: 'Delegate your work to an agent',
          description: 'Plan a well-scoped change, delegate the work to an agent, and review the results.',
          visual: {
            type: 'image',
            src: {
              light: ImageModalTab2Light,
              dark: ImageModalTab2Dark,
            },
            alt: 'Placeholder preview for delegating work to a Copilot agent.',
          },
          cta2: {
            label: 'Start with agents',
            href: '/in-product-messaging/dismiss-and-redirect?notice=accelerate_ipm_copilot_business_onboarding_modal&group=engage&dismiss_scope=user&destination_key=accelerate_ipm_copilot_business_onboarding_modal_agents',
          },
        },
        {
          title: 'Customize your agent',
          heading: 'Customize your agent',
          description: 'Use third-party agents, connect MCPs, or create custom agents to add new skills and context.',
          visual: {
            type: 'image',
            src: {
              light: ImageModalTab3Light,
              dark: ImageModalTab3Dark,
            },
            alt: 'Placeholder preview for customizing a Copilot agent.',
          },
          cta2: {
            label: 'Create a custom agent',
            href: 'https://docs.github.com/en/copilot/concepts/agents/cloud-agent/about-custom-agents',
            isNewWindow: true,
          },
        },
      ],
    },
  }
}

export default getData
